import { Box } from "@mui/material";
import styled from "styled-components";

export const SubtitleStyled = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    .subtitle {
        font-weight: 500;
        font-size: 24px;
        color: var(--coal-black-color);
        @media (max-width: 576px) {
            font-size: 20px;
        }
    }
    .light-button {
        .MuiButtonBase-root {
            min-width: 162px;
            font-weight: 600 !important;
            font-size: 16px !important;
            color: var(--medium-gray-color) !important;
            border: 1px solid var(--white-sand-color);
        }
    }
`